export default "__VITE_ASSET__CHlpG$gP__"